
import { toast } from 'sonner';
import { playNotificationSound } from './notificationSoundHelper';
import { getBrowserInfo } from './printing/printingBridge';

export { playNotificationSound } from './notificationSoundHelper';

/**
 * Display a notification for successful backup creation
 */
export const notifyBackupSuccess = async (dataType: string, count: string): Promise<void> => {
  toast.success(`Backup of ${count} ${dataType} created successfully!`);
  await playNotificationSound();
};

/**
 * Display a notification for successful backup restoration
 */
export const notifyRestoreSuccess = async (dataType: string, count: string): Promise<void> => {
  toast.success(`Restored ${count} ${dataType} successfully!`);
  await playNotificationSound();
};

/**
 * Display a notification with printing information for debugging
 */
export const notifyPrintDebug = (): void => {
  const browserInfo = getBrowserInfo();
  console.log("Print environment information:", browserInfo);
  toast.info("Print environment information logged to console");
};
